import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { loadMenu, openCloseMenu, mobileMenuShow } from '../../../reducers/models/api'
import { Link, useParams } from 'react-router-dom';
import ErrorAdd from "../../../util/ErrorAdd";

function Controller() {

    const { url_controller, url_method } = useParams();
    const dispatch = useDispatch()

    const stateApi = useSelector((state) => state.api); //Размеры окна
    const [menuLoading, setMenuLoading] = useState(false);
    const [menuLog, setMenuLog] = useState(null);

    useEffect(() => {
        if (stateApi.menuLoaded === false) {
            setMenuLoading(true);
            setMenuLog(null);

            axios.get('/api_main/api/menuDataList', { params: { ID_Service: process.env.REACT_APP_ID_SERVICE } })
                .then((res) => {
                    if (res.data.Status === 1) {
                        dispatch(loadMenu({ list: res.data.Data }));
                    }
                    else {
                        setMenuLog(res.data.Error);

                    }
                    setMenuLoading(false);
                })
                .catch((err) => {
                    setMenuLog('Неизвестная ошибка!');
                    setMenuLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }, []);


    return (
        <>
            <div className="api_menu_m_btn" onClick={() => dispatch(mobileMenuShow({ val: true }))}>
                <FontAwesomeIcon icon={faBars} size='2x' />
            </div>
            {stateApi.mobileMenuShow === true &&
                (
                    <div className='api_menu_m'>
                        <div className='d-flex'>
                            <div className='title p-3'>Для разработчиков</div>
                            <FontAwesomeIcon className='mt-10 mr-10' icon={faXmark} size='3x' style={{ marginLeft: 'auto', opacity: '0.5' }} onClick={() => dispatch(mobileMenuShow({ val: false }))} />
                        </div>

                        <div>
                            <Link preventScrollReset to={"/api/"} onClick={() => dispatch(mobileMenuShow({ val: false }))}><div className={url_controller == null ? 'item_main one active' : 'item_main one'} >Начало</div></Link>
                        </div>

                        {stateApi.controllers.map(cat =>
                        (
                            <div key={cat.ID_Controller}>
                                <Link preventScrollReset to={"/api/" + cat.Url_Controller} ><div key={cat.ID_Controller} className={cat.Url_Controller === url_controller ? 'item_main active' : 'item_main'} onClick={() => dispatch(openCloseMenu({ id_controller: cat.ID_Controller }))}>{cat.Name_Controller}</div></Link>
                                <ul className={cat.Open === true ? 'item_sub' : 'item_sub hide'}>
                                    {stateApi.menu.filter(a => a.ID_Controller === cat.ID_Controller).map(item => (
                                        <Link to={"/api/" + cat.Url_Controller + "/" + item.Url_Method} key={item.ID_Method} onClick={() => dispatch(mobileMenuShow({ val: false }))}><li className={item.Url_Method === url_method ? 'select' : ''}>{item.Url_Method}</li></Link>
                                    ))}
                                </ul>
                            </div >
                        )
                        )
                        }
                    </div>
                )
            }

            <div className="api_menu"  >
                <div className='title p-3'>Для разработчиков</div>
                <div>
                    <Link preventScrollReset to={"/api/"} ><div className={url_controller == null ? 'item_main one active' : 'item_main one'} >Начало</div></Link>
                </div>
                {stateApi.controllers.map(cat =>
                (
                    <div key={cat.ID_Controller}>
                        <Link preventScrollReset to={"/api/" + cat.Url_Controller} ><div key={cat.ID_Controller} className={cat.Url_Controller === url_controller ? 'item_main active' : 'item_main'} onClick={() => dispatch(openCloseMenu({ id_controller: cat.ID_Controller }))}>{cat.Name_Controller}</div></Link>
                        <ul className={cat.Open === true ? 'item_sub' : 'item_sub hide'}>
                            {stateApi.menu.filter(a => a.ID_Controller === cat.ID_Controller).map(item => (
                                <Link to={"/api/" + cat.Url_Controller + "/" + item.Url_Method} key={item.ID_Method}><li className={item.Url_Method === url_method ? 'select' : ''}>{item.Url_Method}</li></Link>
                            ))}
                        </ul>
                    </div >
                )
                )
                }
            </div >
        </>
    );
}

export default Controller;
